import { render, staticRenderFns } from "./AddNiche.vue?vue&type=template&id=650c9bfd&"
import script from "./AddNiche.vue?vue&type=script&lang=js&"
export * from "./AddNiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports